import { Link } from 'react-router-dom';

function Home() {
  return (
    <div className="p-8 text-center">
      {/* Hero Section with Border */}
      <div className="p-6 border border-gray-300 rounded-lg shadow-sm bg-white max-w-3xl mx-auto mb-12">
        <h1 className="text-4xl font-bold mb-4">Empowering Businesses with Smart, Seamless Payment Solutions</h1>
        <p className="text-blue-800 font-semibold text-lg mb-6">
          Dalcom provides cutting-edge payment technology — trusted by hotels, retail, and entertainment venues worldwide.
        </p>

        <Link to="/products" className="bg-blue-700 text-white py-2 px-4 rounded">
          Explore Our Products
        </Link>
      </div>

      {/* Contact Form Section with Matching Border Width */}
      <div className="p-6 border border-gray-300 rounded-lg shadow-sm bg-white max-w-3xl mx-auto text-left">
        <h2 className="text-2xl font-bold mb-4 text-center">Contact Us</h2>
        <form name="contact" method="POST" data-netlify="true" className="flex flex-col space-y-4">
          <input type="text" name="name" placeholder="Your Name" required className="border p-2 rounded" />
          <input type="email" name="email" placeholder="Your Email" required className="border p-2 rounded" />
          <textarea name="message" placeholder="Your Message" required className="border p-2 rounded" />
          <button type="submit" className="bg-blue-700 text-white py-2 px-4 rounded">
            Send Message
          </button>
        </form>
      </div>
    </div>
  );
}

export default Home;
